import * as BioentityDAO from 'bioentities/BioentityDAO';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import * as ModelActions from 'redux-stores/ModelActions';
import {getStore} from 'redux-stores/Store';
import {ValidationExtras} from 'schemas/SchemaValidationConstants';

export default class ValidationExtrasModelManager extends ModelManager<ManagedModelType.VALIDATION_EXTRAS_BY_BIOENTITY_ID> {
  constructor() {
    super(ManagedModelType.VALIDATION_EXTRAS_BY_BIOENTITY_ID);
  }

  async doFetchMulti(bioentityIds: Array<string>): Promise<void> {
    const {validationExtrasByBioentityId} = await BioentityDAO.bulkGetValidationExtras(bioentityIds);
    const inaccessibleFileIds = bioentityIds.filter((id) => !validationExtrasByBioentityId[id]);
    getStore().dispatch(
      ModelActions.validationExtrasFetchCompleted(validationExtrasByBioentityId, inaccessibleFileIds)
    );
  }

  getModel(bioentityId: string): ValidationExtras | null {
    return getStore().getState().models.validationExtrasByBioentityId[bioentityId] || null;
  }

  override isModelInaccessible(bioentityId: string): boolean {
    return getStore().getState().models.inaccessibleFileIds.includes(bioentityId);
  }
}
